import React from 'react';
import { SpacerTile } from './types/SpacerTile';

export default function Spacer({ tile }: { tile: SpacerTile }) {
  const option = tile.size.options?.[0].value;
  let size;
  switch (option) {
    case 'sm':
      size = 'pt-3 sm:pt-6';
      break;
    case 'md':
      size = 'pt-5 sm:pt-10';
      break;
    case 'lg':
      size = 'pt-8 sm:pt-16';
      break;
    case 'xl':
      size = 'pt-10 sm:pt-20';
      break;
    default:
      size = 'pt-0';
      break;
  }

  return <div className={size} />;
}
